export class SchedulingJob {
    id!: string
    job!: string
    jobName!: string
    start!: Date
    end!: Date
    projectedEnd!: Date
    milestone!: Date
    priority!: number
    reason!: string
    departments!: string
    departmentList!: any[]
    liquidatedDamage!: string
    notes!: string
    divisionName!: string
    prioritySort?: number
}
